// @ts-nocheck
import { useEffect, useState } from "react"
import { useParams, Link, useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { supabaseClient } from "@/lib/supabase/client"
import { useAuth } from "@/components/layout/AuthProvider"
import { Avatar } from "@/components/ui/Avatar"
import { VoteButtons } from "@/components/post/VoteButtons"
import { CommentSection } from "@/components/comments/CommentSection"

export default function PostDetailPage() {
  const { id } = useParams()
  const { supabaseUser } = useAuth()
  const navigate = useNavigate()
  const [post, setPost] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) return
    supabaseClient
      .from("posts")
      .select("*, users!posts_author_id_fkey(id,username,display_name,avatar_url,is_verified), post_topics(topics(id,name,slug))")
      .eq("id", id)
      .single()
      .then(({ data }) => { setPost(data); setLoading(false) })
  }, [id])

  if (loading) return <div className="container-narrow py-8"><div className="skeleton h-64 rounded" /></div>
  if (!post) return <div className="container-narrow py-16 text-center"><p className="font-syne font-bold text-xl mb-2">Post not found</p><Link to="/feed" className="text-brand hover:underline">← Back to feed</Link></div>

  const author = post.users
  const topic = post.post_topics?.[0]?.topics
  const timeAgo = (ts: string) => {
    const d = (Date.now() - new Date(ts).getTime()) / 1000
    if (d < 60) return "just now"
    if (d < 3600) return Math.floor(d/60) + "m ago"
    if (d < 86400) return Math.floor(d/3600) + "h ago"
    return Math.floor(d/86400) + "d ago"
  }

  return (
    <div className="container-narrow py-4 pb-20 lg:pb-4">
      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
        <div className="post-card flex mb-4">
          {/* Vote column */}
          <div className="flex-shrink-0">
            <VoteButtons
              postId={post.id} userId={supabaseUser?.id || null}
              currentVote={null} score={post.vote_score || 0}
              onVoteChange={() => {}}
            />
          </div>

          {/* Content */}
          <div className="flex-1 p-4 min-w-0">
            {/* Meta */}
            <div className="flex items-center gap-1.5 text-xs text-muted-fg mb-2 flex-wrap">
              {topic && <Link to={`/topics/${topic.slug}`} className="font-bold hover:text-brand">t/{topic.name}</Link>}
              {topic && <span>·</span>}
              <span>Posted by</span>
              {author && <Link to={`/profile/${author.username}`} className="hover:underline">u/{author.username}</Link>}
              <span>·</span>
              <span>{timeAgo(post.published_at || post.created_at)}</span>
            </div>

            <h1 className="font-syne font-bold text-xl leading-snug mb-3">{post.title}</h1>

            {post.content && (
              <div className="text-sm leading-relaxed text-foreground/90 whitespace-pre-wrap mb-4">
                {post.content}
              </div>
            )}

            {/* Action bar */}
            <div className="post-actions border-t border-border pt-3">
              <button className="action-btn">
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                </svg>
                Share
              </button>
              {supabaseUser?.id === author?.id && (
                <Link to={`/post/edit/${post.id}`} className="action-btn">Edit</Link>
              )}
            </div>
          </div>
        </div>

        {/* Comments */}
        <div className="panel p-4">
          <CommentSection postId={post.id} userId={supabaseUser?.id || null} />
        </div>
      </motion.div>
    </div>
  )
}
